var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('a',{staticClass:"tooltip",attrs:{"data-tooltip":_vm.showTooltip
      ? ("Tests: " + (_vm.item.chocoPackage.PackageTestResultStatus))
      : false,"href":_vm.item.chocoPackage.PackageTestResultUrl !== ''
      ? _vm.item.chocoPackage.PackageTestResultUrl
      : _vm.item.chocoPackage.GalleryDetailsUrl,"target":"_blank"}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }